import 'moment/locale/pt-br';

import { pluralize } from '../utils/translation';

export default {
  checkIn: 'Data de entrada',
  checkOut: 'Data de saída',
  guests: 'Hóspedes',
  rooms: 'Quartos',
  adults: 'Adultos',
  children: 'Crianças',
  checkAvailability: 'Verificar disponibilidade',
  roomCount: ({ count }) => pluralize(
    count,
    '{count} quartos',
    ['{count} quarto', 1]
  ),
  adultCount: ({ count }) => pluralize(
    count,
    '{count} adultos',
    ['{count} adulto', 1]
  ),
  childrenCount: ({ count }) => pluralize(
    count,
    '{count} crianças',
    ['{count} criança', 1]
  )
};
